import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import SForm from 'shared/components/Form';

import AutoFormInput from '../AutoFormInput';
import ImageBW from '../ImageBoundsWrapper';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class Form extends Component {
  state = {};

  render() {
    const activeBG = require(asset`RoundedRect_Pink@2x.png`);
    const nonActiveBG = require(asset`RoundedRect_Grey@2x.png`);
    return (
      <SForm
        {...this.props}
        render={args => {
          const {
            header,
            steps,
            currentStep,
            status,
            complete,
            getValidation,
            nextTouchHandler,
            prevTouchHandler,
            validatedHandler,
            inputChangeHandler,
            layoutChangeHandler,
          } = args;

          const { formInputList, submitButtonText } = steps[currentStep];
          let formBody;
          if (formInputList) {
            formBody = formInputList.map((component, index) => {
              if (!component.hide) {
                return (
                  <AutoFormInput
                    {...component}
                    key={`${component.id}-${index}`}
                    emitValidated={validatedHandler}
                    emitInput={inputChangeHandler}
                    emitLayoutChange={layoutChangeHandler}
                    validated={getValidation(component.id)}
                  />
                );
              }
            });
          }

          return (
            <>
              {!this.props.hideTopBar && (
                <div className="web-form-top-bar">
                  <Col className="left">
                    <a className="link" onClick={prevTouchHandler}>
                      {header.backButtonText ? header.backButtonText : getText(TEXT_KEY.CANCEL)}
                    </a>
                  </Col>
                  {header.helpLink && (
                    <Col className="right">
                      <a className="link" href={header.helpLink} target="_blank" rel="noopener noreferrer">
                        {getText(TEXT_KEY.NEED_HELP)}
                      </a>
                    </Col>
                  )}
                </div>
              )}
              <div className="form-container">
                <div className="form-scrollContainer">
                  {!!header.title && <h4 className="form-title">{header.title}</h4>}

                  {!!this.props.subtitle && <div>{this.props.subtitle}</div>}

                  <div className={this.props.formCustomContent ? 'form-custom-content' : 'form-content'}>
                    {steps.length > 0 && formBody}
                    {status.length > 0 && <p className="form-wide-status">{status}</p>}
                    {!!this.props.customConfirmButton ? (
                      <div
                        className="custom-confirm-button-container"
                        style={(!!this.props.customStyle && this.props.customStyle) || {}}
                        onClick={!!complete ? nextTouchHandler : null}
                      >
                        <ImageBW
                          source={!!complete ? activeBG : nonActiveBG}
                          ibw={require(asset`Confirm_Button.ibw`)}
                          style={{ objectFit: 'contain' }}
                          className="custom-confirm-button"
                          innerStyle={{
                            cursor: 'pointer',
                          }}
                        >
                          <div className="custom-confirm-button-content">
                            <span
                              className={
                                !!complete ? 'custom-confirm-button-text active' : 'custom-confirm-button-text'
                              }
                              data-label={submitButtonText}
                            >
                              {submitButtonText}
                            </span>
                          </div>
                        </ImageBW>
                      </div>
                    ) : (
                      <div
                        className={!!complete ? 'form-confirm-button' : 'form-confirm-button disabled'}
                        onClick={!!complete ? nextTouchHandler : null}
                      >
                        <img src={!!complete ? activeBG : nonActiveBG} alt="Complete" />
                        <p className="form-confirm-button-label">{submitButtonText}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        }}
      />
    );
  }
}
